module.exports = __webpack_public_path__ + "assets/img/free_24.18b93e34.png";